document.addEventListener('DOMContentLoaded', function () {
  const playBtns = document.querySelectorAll(
    '.festool-action-section__play'
  );
  playBtns.forEach(function (playBtn) {
    playBtn.addEventListener('click', function () {
      console.log('>>>');
      const popup = document.querySelector(
        '.instagram-popup-overlay'
      );
      const iframe = popup.querySelector(
        '.instagram-embed-source iframe'
      );
      const closeBtn = popup.querySelector(
        '.instagram-popup-close'
      );
      // Original Shorts URL
      const videoUrl = playBtn.getAttribute('video_url');
      if (!videoUrl || !popup || !iframe) return;
      // Video ID extract
      let videoId = '';
      if (videoUrl.includes('/shorts/')) {
        videoId = videoUrl
          .split('/shorts/')[1]
          .split(/[?&]/)[0];
      }
      console.log('Video ID:', videoId);
      // YouTube Embed URL
      const embedUrl =
        'https://www.youtube.com/embed/' +
        videoId +
        '?autoplay=1&mute=1&rel=0';
      console.log('Embed URL:', embedUrl);
      // iframe me URL set
      iframe.src = embedUrl;
      // Popup open
      popup.classList.add('active');
      // Close
      closeBtn.onclick = function () {
        popup.classList.remove('active');
        // Video stop
        iframe.src = '';
      };
    });
  });
});